import { OP, STATUS } from "../../constant";

const INITIAL_STATE = {
  listLogsStatus: STATUS.DEFAULT,
  listLogsMessage: "",
  listLogsResult: null,

  listFolderLogsStatus: STATUS.DEFAULT,
  listFolderLogsMessage: "",
  listFolderLogsResult: null,

  viewLogStatus: STATUS.DEFAULT,
  viewLogMessage: "",
  viewLogResult: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    /** ------------- list logs ------------- */
    case OP.LIST_LOGS_LOADING:
      return {
        ...state,
        listLogsStatus: STATUS.LOADING,
      };

    case OP.LIST_LOGS_SUCCESS:
      return {
        ...state,
        listLogsStatus: STATUS.SUCCESS,
        listLogsMessage: "",
        listLogsResult: payload,
      };

    case OP.LIST_LOGS_FAILURE:
      return {
        ...state,
        listLogsStatus: STATUS.ERROR,
        listLogsMessage: payload,
        listLogsResult: null,
      };

    case OP.LIST_LOGS_RESET:
      return {
        ...state,
        listLogsStatus: STATUS.DEFAULT,
        listLogsMessage: "",
        listLogsResult: null,
      };

    /** ------------- list folder logs ------------- */
    case OP.LIST_FOLDER_LOGS_LOADING:
      return {
        ...state,
        listFolderLogsStatus: STATUS.LOADING,
      };

    case OP.LIST_FOLDER_LOGS_SUCCESS:
      return {
        ...state,
        listFolderLogsStatus: STATUS.SUCCESS,
        listFolderLogsMessage: "",
        listFolderLogsResult: payload,
      };

    case OP.LIST_FOLDER_LOGS_FAILURE:
      return {
        ...state,
        listFolderLogsStatus: STATUS.ERROR,
        listFolderLogsMessage: payload,
        listFolderLogsResult: null,
      };

    case OP.LIST_FOLDER_LOGS_RESET:
      return {
        ...state,
        listFolderLogsStatus: STATUS.DEFAULT,
        listFolderLogsMessage: "",
        listFolderLogsResult: null,
      };

    /** ------------- view log ------------- */
    case OP.VIEW_LOG_LOADING:
      return {
        ...state,
        viewLogStatus: STATUS.LOADING,
      };

    case OP.VIEW_LOG_SUCCESS:
      return {
        ...state,
        viewLogStatus: STATUS.SUCCESS,
        viewLogMessage: "",
        viewLogResult: payload,
      };

    case OP.VIEW_LOG_FAILURE:
      return {
        ...state,
        viewLogStatus: STATUS.ERROR,
        viewLogMessage: payload,
        viewLogResult: null,
      };

    case OP.VIEW_LOG_RESET:
      return {
        ...state,
        viewLogStatus: STATUS.DEFAULT,
        viewLogMessage: "",
        viewLogResult: null,
      };

    default:
      return state;
  }
};
